module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("LifeBeg-1")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "bd-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Recent Doonesbury Books by G.B. Trudeau")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Read My Lips, Make My Day, Eat Quiche and Die!")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Give Those Nymphs Some Hooters!")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("You’re Smokin’ Now, Mr. Butts!")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("I’d Go With the Helmet, Ray")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Welcome to Club Scud!")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("What Is It, Tink, Is Pan in Trouble?")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Quality Time on Highway 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Washed Out Bridges and Other Disasters")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("In Search of Cigarette Holder Man")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Doonesbury Nation")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Virtual Doonesbury")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Planet Doonesbury")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Buck Wild Doonesbury")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Duke 2000: Whatever It Takes")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Revolt of the English Majors ")]), _vm._v(" "), _c('p', {
    staticClass: "bd-8",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Special Collections")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Doonesbury Chronicles")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Doonesbury’s Greatest Hits")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The People’s Doonesbury")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Doonesbury Dossier: The Reagan Years")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Doonesbury Deluxe: Selected Glances Askance")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Recycled Doonesbury: Second Thoughts on a Gilded Age")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Action Figure!")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Portable Doonesbury")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Flashbacks: Twenty-five Years of Doonesbury")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-00",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("The Bundled Doonesbury")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0f4872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pod03.vue
// module id = 60
// module chunks = 0